var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAnnotationImported = function SvgAnnotationImported(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 20,
    height: 20,
    rx: 4,
    fill: "currentColor",
    fillOpacity: 0.2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 16,
    width: 14,
    height: 3,
    rx: 1.5,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9913 5C11.0792 5 10.3398 5.73939 10.3398 6.65147V9.9544C10.3398 10.0341 10.3455 10.1125 10.3564 10.1892L10.1927 10.0288C9.60953 9.45727 8.67632 9.45727 8.09313 10.0288C7.49305 10.6169 7.49304 11.5831 8.09313 12.1712L10.6002 14.6281C11.3778 15.3902 12.6222 15.3902 13.3999 14.6281L15.907 12.1712C16.5071 11.5831 16.5071 10.6169 15.907 10.0288C15.3238 9.45727 14.3906 9.45727 13.8074 10.0288L13.6232 10.2093C13.6361 10.1262 13.6428 10.0411 13.6428 9.9544V6.65147C13.6428 5.73939 12.9034 5 11.9913 5Z",
    fill: "currentColor"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAnnotationImported);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "annotation-imported.0b230d1400817361556f3de2304a11a0.svg";